import { useState, useEffect } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../apiConfig";
import FullscreenLoader from "../components/FullscreenLoader";

function SetupGuard() {
  const location = useLocation();
  const [status, setStatus] = useState({ loading: true, needsSetup: false });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setStatus({ loading: false, needsSetup: false });
      return;
    }
    const controller = new AbortController();

    axios
      .get(`${API_URL}/setup/status`, {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
        timeout: 30000,
      })
      .then((res) => setStatus({ loading: false, needsSetup: res.data.needs_setup === true }))
      .catch(() => setStatus({ loading: false, needsSetup: false }));

    return () => controller.abort();
  }, []);

  if (status.loading) {
    return <FullscreenLoader alt="Kataloji" />;
  }

  const onSetupPage = location.pathname === "/setup";
  if (status.needsSetup && !onSetupPage) {
    return <Navigate to="/setup" replace />;
  }
  if (!status.needsSetup && onSetupPage) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}

export default SetupGuard;
